import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2204">
      <div className="dark" data-id="element-2205">
        <Hero data-id="element-2206" />
      </div>
      <WhyUs data-id="element-2207" />
      <Services data-id="element-2208" />
      <HowItWorks data-id="element-2209" />
      <FAQ data-id="element-2210" />
      <Reviews data-id="element-2211" />
      <CtaBanner data-id="element-2212" />
    </main>;
}